module.exports = __webpack_public_path__ + "static/media/home-alt.cf30defc.svg";